import { render, staticRenderFns } from "./ConversationDurationBarChart.vue?vue&type=template&id=3f122415&"
import script from "./ConversationDurationBarChart.vue?vue&type=script&lang=js&"
export * from "./ConversationDurationBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports